module.exports = __webpack_public_path__ + "static/media/team--peter.1e7d44d2.jpg";